export { default as SearchInput } from './search-input';
